import React, { useMemo } from 'react'
import { DateTime } from 'luxon'
import { formatDateDomini } from '@lib/utils'

import { useBookTopCharts } from '@hooks/book/useBookTopChart'
import { TopRankTemplateProps, WithTopRankTemplateProps } from './interface'

export function withTopRankTemplate(Component: React.FC<TopRankTemplateProps>) {
  function WithTopRankTemplate({
    title,
    seoTitle,
    type,
  }: WithTopRankTemplateProps) {
    const dt = DateTime.local()
    const {
      data,
      query,
      limit,
      isLoading,
      lastWeek,
      isLoadingToggleBookLike,
      handleCategoryChange,
      handleBookTypeChange,
      nextWeek,
      prevWeek,
      handleLikeBook,
      handleFetchNextPage,
    } = useBookTopCharts()

    const disablePrev = useMemo(
      () =>
        query.startDate.toFormat('yyyy-MM-dd') ===
        dt.startOf('year').endOf('week').toFormat('yyyy-MM-dd'),
      [query.startDate, dt]
    )

    const disableNext = useMemo(
      () =>
        query.endDate.toFormat('yyyy-MM-dd') ===
        lastWeek.endOf('week').toFormat('yyyy-MM-dd'),
      [query.endDate, lastWeek]
    )

    const dateOfWeek = `${formatDateDomini(
      query.startDate.toString()
    )} - ${formatDateDomini(query.endDate.toString())}`

    const componentProps = {
      title,
      seoTitle,
      query,
      books: data,
      isLoading,
      limit,
      dateOfWeek,
      disablePrev,
      disableNext,
      isLoadingToggleBookLike,
      type,
      handleCategoryChange,
      handleBookTypeChange,
      nextWeek,
      prevWeek,
      handleLikeBook,
      handleFetchNextPage,
    }

    return <Component {...componentProps} />
  }

  return WithTopRankTemplate
}
